"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TtlCache = void 0;
class TtlCache {
    constructor({ ttl = 10000, cleanupInterval = 5000 } = {}) {
        this.cache = new Map();
        this.ttl = ttl;
        this.cleanupInterval = cleanupInterval;
        this.scheduleCleanup();
    }
    // Set a value with expiration
    set(key, value) {
        this.cache.set(key, { value, expiresAt: Date.now() + this.ttl });
    }
    get(key) {
        const entry = this.cache.get(key);
        if (!entry)
            return undefined;
        return entry.value;
    }
    wrap(fn, cacheKeyFn) {
        return (...args) => {
            const cacheKey = cacheKeyFn(...args);
            const cachedValue = this.get(cacheKey);
            if (cachedValue !== undefined) {
                return cachedValue;
            }
            else {
                const value = fn(...args);
                this.set(cacheKey, value);
                return value;
            }
        };
    }
    cleanup() {
        const now = Date.now();
        for (const [key, entry] of this.cache) {
            if (entry.expiresAt <= now) {
                this.cache.delete(key);
            }
        }
        this.scheduleCleanup();
    }
    scheduleCleanup() {
        var _a, _b;
        /**
         * Required due to source code evaluation in vm context compatibility
         * Temporary workaround until for internal needs
         * Should be removed soon
         */
        if (typeof setTimeout !== 'function') {
            return;
        }
        this.timeoutId = setTimeout(() => this.cleanup(), this.cleanupInterval);
        (_b = (_a = this.timeoutId).unref) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    // Clear the entire cache and stop the cleanup interval
    clear() {
        this.cache.clear();
    }
    destroy() {
        this.clear();
        clearTimeout(this.timeoutId);
    }
}
exports.TtlCache = TtlCache;
